/* ==========================================================================
   Mirah — search.js
   <search-overlay>: full-width panel with predictive results
   (Predictive Search API + sections/predictive-search.liquid).
   ========================================================================== */
(function () {
  'use strict';

  var d = document;
  var S = window.MirahSettings || {};
  var routes = S.routes || {};
  var Theme = window.Theme || (window.Theme = {});

  class SearchOverlay extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;
      this.panel = this.querySelector('.search-overlay__panel');
      this.input = this.querySelector('[data-search-input]');
      this.body = this.querySelector('[data-search-results]');
      this.defaults = this.querySelector('[data-search-default]');
      this.live = this.querySelector('[data-search-live]');
      this.cache = {};
      this.controller = null;

      d.addEventListener('click', function (e) {
        if (e.target.closest('[data-search-open]')) { e.preventDefault(); this.open(); }
      }.bind(this));
      this.addEventListener('click', function (e) { if (e.target.closest('[data-search-close]')) this.close(); }.bind(this));
      this.addEventListener('keydown', function (e) { if (e.key === 'Escape') this.close(); }.bind(this));
      if (this.input.hasAttribute('role')) {
        this.input.addEventListener('input', (Theme.debounce || function (f) { return f; })(this.onInput.bind(this), 250));
      }
    }

    open() {
      this.classList.add('is-open');
      this.setAttribute('aria-hidden', 'false');
      if (Theme.lockScroll) Theme.lockScroll();
      if (Theme.trapFocus) Theme.trapFocus(this.panel, this.input);
      var header = d.querySelector('[data-header]');
      if (header) header.classList.remove('is-hidden');
    }

    close() {
      if (!this.classList.contains('is-open')) return;
      this.classList.remove('is-open');
      this.setAttribute('aria-hidden', 'true');
      if (Theme.unlockScroll) Theme.unlockScroll();
      if (Theme.releaseFocus) Theme.releaseFocus();
    }

    onInput() {
      var q = this.input.value.trim();
      if (!q) {
        this.live.hidden = true;
        this.defaults.hidden = false;
        this.input.setAttribute('aria-expanded', 'false');
        return;
      }
      if (this.cache[q]) return this.render(this.cache[q]);

      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      var url = routes.predictiveSearch + '?q=' + encodeURIComponent(q) +
        '&section_id=predictive-search' +
        '&resources[type]=product,collection,page,article' +
        '&resources[limit]=8' +
        '&resources[options][unavailable_products]=last';
      this.body.classList.add('is-loading');
      var self = this;
      fetch(url, { signal: this.controller.signal })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var markup = (doc.querySelector('#shopify-section-predictive-search') || doc.body).innerHTML;
          self.cache[q] = markup;
          self.render(markup);
        })
        .catch(function (err) { if (err.name !== 'AbortError') self.body.classList.remove('is-loading'); });
    }

    render(markup) {
      this.body.classList.remove('is-loading');
      this.live.innerHTML = markup;
      this.live.hidden = false;
      this.defaults.hidden = true;
      this.input.setAttribute('aria-expanded', 'true');
      if (Theme.iconClone) Theme.iconClone(this.live);
      if (Theme.motionOn && window.gsap) {
        gsap.fromTo(this.live.querySelectorAll('[data-stagger-item]'), { y: 40, opacity: 0 }, { y: 0, opacity: 1, stagger: 0.06, duration: 0.8, ease: 'expo.out' });
      }
    }
  }
  if (!customElements.get('search-overlay')) customElements.define('search-overlay', SearchOverlay);
})();
